$(document).ready(function(){
    const collapsibleHeader = $('footer .collapsible-header');
    const collapsibleBody = $('footer .collapsible-body');
    $('.collapsible').collapsible();
        if (screen.width < 768) {
            collapsibleHeader.parent().removeClass('active');
            collapsibleHeader.removeClass('active');
            collapsibleBody.css('display', 'none');
            $( "footer .collapsible-header" ).on('click', function() {
                $(".more",this).toggle();
                $(".less", this).toggle();
            });
        } else {
            $('.collapsible').collapsible('destroy');
            collapsibleHeader.addClass('noHover');
        }

    $('.faq-collapse').collapsible();
});